import { create } from 'zustand';

import { createStoreSelectors } from 'utilities';

export type NavRevealState = 'top' | 'hidden' | 'revealed';

interface State {
  isScrollToTopVisible: boolean;
  setScrollToTopVisible: (isScrollToTopVisible: State['isScrollToTopVisible']) => void;
  isCloseToBottom: boolean;
  setIsCloseToBottom: (isCloseToBottom: State['isCloseToBottom']) => void;
  navRevealState: NavRevealState;
  setNavRevealState: (navRevealState: State['navRevealState']) => void;
}

const useStore = create<State>()((set) => ({
  isScrollToTopVisible: false,
  setScrollToTopVisible: (v: boolean) => set({ isScrollToTopVisible: v }),
  isCloseToBottom: false,
  setIsCloseToBottom: (v: boolean) => set({ isCloseToBottom: v }),
  navRevealState: 'top',
  setNavRevealState: (navRevealState: NavRevealState) => set({ navRevealState }),
}));

export const store = createStoreSelectors(useStore);
